import { render, staticRenderFns } from "./usersDatatable.vue?vue&type=template&id=59790d7d"
import script from "./usersDatatable.vue?vue&type=script&lang=js"
export * from "./usersDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports